"use client";

import { ErrorMessage } from "@/components/error-message";
import { getErrorMessage } from "@/utils/error-messages";

export default function ErrorPage() {
  const { title, message } = getErrorMessage("500");

  return <ErrorMessage title={title} message={message} />;
}
